function ArrowRight() {
  return (
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.2645 0.139148L7.04353 0.360086C6.89709 0.506523 6.89709 0.743961 7.04353 0.89043L12.6215 6.46837H0.875C0.667906 6.46837 0.5 6.63627 0.5 6.84337V7.15587C0.5 7.36296 0.667906 7.53087 0.875 7.53087H12.6215L7.04353 13.1088C6.89709 13.2552 6.89709 13.4927 7.04353 13.6391L7.2645 13.8601C7.41094 14.0065 7.64838 14.0065 7.79481 13.8601L14.3902 7.26477C14.5366 7.11834 14.5366 6.8809 14.3902 6.73443L7.79481 0.139148C7.64838 -0.00732031 7.41094 -0.00732031 7.2645 0.139148Z"
        fill="#007AC7"
      />
    </svg>
  );
}

export default ArrowRight;
